import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M10 17h4V5H2v12h3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M20 17h2v-3.34a4 4 0 0 0-1.17-2.83L19 9h-5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M14 17h1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "7.5", cy: "17.5", r: "2.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "17.5", cy: "17.5", r: "2.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Truck";
const Truck = memo(themed(Icon));
export {
  Truck
};
//# sourceMappingURL=truck.js.map
